import script from "./invoice-page.vue?vue&type=script&setup=true&lang=js"
export * from "./invoice-page.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__